"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link GatewayClientKey}
 */
var GatewayClientKeySerialiserClass = /** @class */ (function (_super) {
    __extends(GatewayClientKeySerialiserClass, _super);
    function GatewayClientKeySerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link GatewayClientKey} from the stream
     *
     * @param bis the input stream
     * @return    the {@link GatewayClientKey} that was read
     */
    GatewayClientKeySerialiserClass.prototype.read = function (bis) {
        var type = Codec.readString(bis);
        var id = Codec.readString(bis);
        return {
            type: type,
            id: id
        };
    };
    /**
     * Write a {@link GatewayClientKey} from the stream
     *
     * @param bos   the output stream
     * @param value the {@link GatewayClientKey} to write
     */
    GatewayClientKeySerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.type);
        Codec.writeString(bos, value.id);
    };
    return GatewayClientKeySerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.GatewayClientKeySerialiserClass = GatewayClientKeySerialiserClass;
/**
 * The {@link GatewayClientKeySerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.GatewayClientKeySerialiser = new GatewayClientKeySerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/gateway-client-key-serialiser.js
// module id = 802
// module chunks = 1